import React from 'react';
import {Image, StyleSheet, TouchableOpacity, View} from 'react-native';

import {AppRoute} from '../models/AppRoute';
import useAppNavigation from '../navigation/useAppNavigation';
import theme from '../style/theme';

import Text from './ui-controls/Text';

const PromotionSearchAbbreviatedTile = ({item, onPress}) => {
  const navigation = useAppNavigation();

  const _onPress = () => {
    if (onPress) {
      onPress(item);
    } else {
      navigation.navigate(AppRoute.PROMOTION, {
        promotion: item,
      });
    }
  };

  return (
    <TouchableOpacity onPress={() => _onPress(item)} style={styles.item} key={item.id}>
      <View style={styles.itemInside}>
        <View style={styles.leftCol}>
          {item.heroImage?.url ? (
            <Image
              source={{uri: item.heroImage.url}}
              style={styles.tileImage}
              resizeMode="contain"
            />
          ) : null}
        </View>
        <View style={styles.rightCol}>
          <Text style={styles.itemText}>{item.bannerHeadline}</Text>
          <Text style={styles.copyStyle} numberOfLines={2} adjustsFontSizeToFit={false}>
            {item.firstCopy || item.description}
          </Text>
        </View>
      </View>
    </TouchableOpacity>
  );
};

export default PromotionSearchAbbreviatedTile;

const styles = StyleSheet.create({
  // Image Side
  leftCol: {
    flex: 1,
    marginVertical: 1,
    justifyContent: 'center',
  },
  tileImage: {
    width: '100%',
    // aspectRatio: 760/500,
    aspectRatio: 1,
    marginVertical: 4,
  },
  item: {
    borderWidth: 0.5,
    borderColor: 'grey',
    borderRadius: 4,
    paddingLeft: 4,
    backgroundColor: 'white',
  },
  itemInside: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  // Text side
  rightCol: {
    flex: 4,
    paddingHorizontal: 12,
    paddingVertical: 4,
    alignSelf: 'stretch',
    // justifyContent: 'space-between',
  },
  nameRow: {
    flexDirection: 'row',
    borderWidth: 1,
  },
  itemText: {
    color: theme.colour.text.heading.primary,
    fontSize: 16,
    fontWeight: 'bold',
  },
  priceButtonRow: {
    flexDirection: 'row',
    alignSelf: 'center',
  },
  itemQty: {
    color: 'grey',
    fontSize: 12,
  },
  priceLine: {
    flexDirection: 'row',
    alignItems: 'baseline',
  },
  originalPrice: {
    color: 'grey',
    fontSize: 12,
    fontWeight: 'bold',
  },
  price: {
    fontSize: 12,
    color: theme.colour.text.heading.primary,
  },
  priceUnit: {
    fontSize: 12,
    color: 'grey',
  },
  basketButtons: {
    flex: 1,
    alignItems: 'flex-end',
    justifyContent: 'center',
    marginRight: 8,
  },
  copyStyle: {
    paddingTop: 2,
    lineHeight: 16,
    fontSize: 13,
  },
});
